export const logo = require('../theme/images/logo.png');
export const avatar = require('../theme/images/avatar.png');
export const bannerImage = require('../theme/images/banner.jpg');
export const bannerImageMobile = require('../theme/images/banner.jpg');

export const homeBanner = require('../theme/images/home_banner.jpg');
export const serviceBanner = require('../theme/images/banner.jpg');
export const consortiumBanner = require('../theme/images/banner.jpg');
export const productionBaselineBanner = require('../theme/images/banner.jpg');
export const kpiBanner = require('../theme/images/banner.jpg');
export const actionsTrackingBanner = require('../theme/images/banner.jpg');
export const documentsBanner = require('../theme/images/banner.jpg');

export const loginBackground = require('../theme/images/login.jpg'); //login_3_alt.jpg
export const accountBackground = require('../theme/images/banner.jpg');
export const contactBackground = require('../theme/images/contact_banner.jpg');